import { queryKeys } from '@qse/api'
import { useQueryClient } from '@tanstack/react-query'

import { type FolderDeletionEvent, useFolderDeletionListener } from './use-folder-deletion-listener'

/**
 * Global hook that listens for folder deletion events and invalidates all relevant queries
 * This should be used at the app level to ensure all components stay in sync
 */
export const useGlobalFolderDeletionListener = () => {
  const queryClient = useQueryClient()

  const handleFolderDeleted = (event: FolderDeletionEvent) => {
    console.log('📁 Global folder deletion detected, invalidating all relevant queries:', event)

    // Invalidate all file search queries to refresh folder lists everywhere
    queryClient.invalidateQueries({
      queryKey: queryKeys.files.lists(),
    })

    // Invalidate specific parent folder queries if we know the parent
    if (event.parentId) {
      queryClient.invalidateQueries({
        queryKey: queryKeys.files.list({ parentId: event.parentId }),
      })
    }

    // Invalidate specific infinite queries with parent
    if (event.parentId) {
      queryClient.invalidateQueries({
        queryKey: queryKeys.files.list({ parentId: event.parentId }),
      })
    }

    // Invalidate folder details queries
    queryClient.invalidateQueries({
      queryKey: queryKeys.files.details(),
    })

    // Invalidate specific folder details
    queryClient.invalidateQueries({
      queryKey: queryKeys.files.detail(event.folderId),
    })
  }

  useFolderDeletionListener(handleFolderDeleted)
}
